import type { FastifyInstance } from 'fastify'
import { SearchController } from './search.controller.js'
import { authMiddleware } from '../../middleware/auth.middleware.js'

export async function searchRoutes(app: FastifyInstance) {
  const controller = new SearchController()

  // Public routes
  app.get('/', controller.search.bind(controller))
  app.get('/pois', controller.searchPOIs.bind(controller))
  app.get('/feed', controller.getFeed.bind(controller))

  // Protected routes (require authentication)
  app.post<{ Params: { planId: string } }>(
    '/index/:planId',
    { preHandler: [authMiddleware] },
    controller.indexPlan.bind(controller)
  )
  app.delete<{ Params: { planId: string } }>(
    '/index/:planId',
    { preHandler: [authMiddleware] },
    controller.removePlan.bind(controller)
  )
}
